__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "marketplace-shell-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@kar-dmp/ignite", "3.28.3", () => (Promise.all([__webpack_require__.e(7682), __webpack_require__.e(6635), __webpack_require__.e(9506), __webpack_require__.e(9783)]).then(() => (() => (__webpack_require__(26635))))));
			register("@kar-dmp/omp-shared-library", "12.5.0", () => (Promise.all([__webpack_require__.e(7682), __webpack_require__.e(7189), __webpack_require__.e(4789), __webpack_require__.e(9783), __webpack_require__.e(1259), __webpack_require__.e(8849)]).then(() => (() => (__webpack_require__(54789))))));
			register("@kar-dmp/pattern-library", "8.7.2", () => (Promise.all([__webpack_require__.e(8865), __webpack_require__.e(3087), __webpack_require__.e(514), __webpack_require__.e(7189), __webpack_require__.e(4932)]).then(() => (() => (__webpack_require__(18171))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(3536).then(() => (() => (__webpack_require__(53536))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(97950))), 1);
			register("react-router-dom", "6.9.0", () => (__webpack_require__.e(3245).then(() => (() => (__webpack_require__(53245))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(65043))), 1);
			register("styled-components", "5.3.5", () => (Promise.all([__webpack_require__.e(4574), __webpack_require__.e(219)]).then(() => (() => (__webpack_require__(94574))))));
			initExternal(66651);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};